import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="call, phone"><path d="M10.25 8L9 3.75H7.00236H3.75188C3.75063 3.83318 3.75 3.91652 3.75 4C3.75 6.96726 4.54531 9.74877 5.93438 12.143C7.35756 14.596 9.40402 16.6424 11.857 18.0656C14.2512 19.4547 17.0327 20.25 20 20.25H20.25V15L16 13.75L14.1918 15.6335C11.6758 14.3749 9.62505 12.3242 8.36647 9.80819L10.25 8Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCall;
